import { useCallback, useEffect, useState } from "react";
import { getBadges } from "../customerApi";

const ZERO = { open: 0, unread: 0, sessions_90d: 0 };

// 계정 메뉴 배지 — 로그인·화면 이동(routeKey)·60초마다 다시 읽는다
export default function useBadges(enabled, routeKey) {
    const [badges, setBadges] = useState(ZERO);
    const reload = useCallback(() => {
        if (!enabled) return;
        getBadges().then((b) => setBadges({ ...ZERO, ...(b || {}) })).catch(() => {});
    }, [enabled]);
    useEffect(() => {
        if (!enabled) { setBadges(ZERO); return undefined; }
        reload();
        const t = setInterval(reload, 60000);
        return () => clearInterval(t);
    }, [enabled, routeKey, reload]);
    return [badges, reload];
}
